import styled from 'styled-components'

import topDecorationBgMobile from 'assets/images/top-decoration-bg.png'

export const StyledTopDecorationFrame = {
  Root: styled.div`
    position: fixed;
    z-index: 1;
    width: 100%;
    top: 0;
    left: 0;
    right: 0;
    height: 300px;
    background: url(${topDecorationBgMobile}) no-repeat center;
    background-size: 100% 100%;
    pointer-events: none;
  `,
}
